import { ApiClient } from '../helpers/api-client/ApiClient'

export default function auth ({ next, nextMiddleware, store }) {
  const handleResponse = response => {
    if (response.status === 401) {
      store.dispatch('flushAuthorize')

      return nextMiddleware()
    }

    return next('/')
  }

  return ApiClient.userMe()
    .then(response => handleResponse(response))
    .catch(error => handleResponse(error.response))
}
